<template>
  <div class="default-layout">
    <app-header
      :unstick-header="unstickHeader"
      :hide-mobile-back-button="hideMobileBackButton"
      @toggle-search="toggleSearch" />
    <slot />
    <!-- MOBILE BOTTOM MENU -->
    <dd-mobile-menu v-if="$screen.isTabletOrMobile($mq)" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppHeader from '@/views/app-header/app-header.vue'
import DdMobileMenu from '@/components/global/dd-mobile-menu.vue'

export default defineComponent({
  name: 'DefaultLayout',

  components: {
    AppHeader,
    DdMobileMenu,
  },

  props: {
    unstickHeader: {
      type: Boolean,
      default: false,
    },
    hideMobileBackButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchActive: false,
    }
  },

  methods: {
    toggleSearch(val: boolean) {
      this.searchActive = val
      if (this.$screen.isMobile(this.$mq)) {
        if (val === true) {
          this.$bodyScroll.disable()
        } else {
          this.$bodyScroll.enable()
        }
      }
    },
  },
})
</script>

<style lang="scss">
.default-layout {
  padding-top: $navbar-mobile-height;

  @include media-breakpoint-up(md) {
    padding-top: $navbar-desktop-height;
  }
}
</style>
